import React from 'react';
import { Search, Package, ChevronDown, ChevronUp } from 'lucide-react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Badge } from '../../ui/badge';

export const ProductSelector = ({
    products,
    selectedProducts,
    productSearch,
    onSearchChange,
    onToggle,
    onSelectAll,
    showList,
    onToggleList,
}) => {
    const filtered = products.filter(p =>
        p.name.toLowerCase().includes(productSearch.toLowerCase())
    );
    const allSelected = filtered.length > 0 && filtered.every(p => selectedProducts.find(sp => sp.id === p.id));

    return (
        <div>
            <div className="flex items-center justify-between mb-2">
                <Label className="flex items-center gap-2">
                    <Package className="w-4 h-4 text-emerald-600" />
                    Produits ({selectedProducts.length} sélectionnés)
                </Label>
                <div className="flex gap-2">
                    <Button variant="ghost" size="sm" onClick={onSelectAll} className="text-xs" data-testid="select-all-products">
                        Tout {allSelected ? 'désélect.' : 'sélect.'}
                    </Button>
                    <Button variant="ghost" size="sm" onClick={onToggleList} className="text-xs">
                        {showList ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
                    </Button>
                </div>
            </div>
            {selectedProducts.length > 0 && (
                <div className="flex flex-wrap gap-1.5 mb-2">
                    {selectedProducts.map(p => (
                        <Badge key={p.id} variant="secondary" className="gap-1 bg-emerald-50 text-emerald-700 rounded-lg cursor-pointer hover:bg-red-50 hover:text-red-600" onClick={() => onToggle(p)}>
                            {p.name} — {p.price ? `${p.price.toFixed(2)} €/${p.unit}` : 'Devis'}
                            <span className="ml-1">×</span>
                        </Badge>
                    ))}
                </div>
            )}
            {showList && (
                <div className="border rounded-xl p-3 space-y-2 max-h-52 overflow-y-auto bg-gray-50/50">
                    <div className="relative">
                        <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400" />
                        <Input
                            value={productSearch}
                            onChange={e => onSearchChange(e.target.value)}
                            placeholder="Rechercher un produit..."
                            className="pl-8 h-8 text-sm rounded-lg"
                            data-testid="product-search"
                        />
                    </div>
                    {filtered.map(p => (
                        <button key={p.id} onClick={() => onToggle(p)}
                            className={`w-full flex items-center justify-between p-2 rounded-lg text-sm transition-colors ${
                                selectedProducts.find(sp => sp.id === p.id) ? 'bg-emerald-100 text-emerald-800' : 'hover:bg-gray-100'
                            }`} data-testid={`product-item-${p.id}`}>
                            <span>{p.name}</span>
                            <span className="text-xs text-gray-500">{p.price ? `${p.price.toFixed(2)} €/${p.unit}` : 'Devis'}</span>
                        </button>
                    ))}
                    {filtered.length === 0 && (
                        <p className="text-center text-sm text-gray-400 py-2">Aucun produit commandable trouvé</p>
                    )}
                </div>
            )}
        </div>
    );
};
